import React from 'react';
import { SearchIcon, EditIcon, TrashIcon, BellIcon, BellOffIcon } from 'lucide-react';
export function SavedSearches() {
  const savedSearches = [{
    id: 1,
    name: 'Construction au Sénégal',
    criteria: 'Pays: Sénégal, Secteur: Construction, Budget: > 500K€',
    lastResults: 12,
    alertsEnabled: true
  }, {
    id: 2,
    name: "Projets agricoles en Côte d'Ivoire",
    criteria: "Pays: Côte d'Ivoire, Secteur: Agriculture",
    lastResults: 8,
    alertsEnabled: true
  }, {
    id: 3,
    name: 'Éducation au Maghreb',
    criteria: 'Pays: Maroc, Tunisie, Algérie, Secteur: Éducation',
    lastResults: 15,
    alertsEnabled: false
  }];
  return <div className="bg-white rounded-xl shadow-md overflow-hidden h-full" data-id="element-244">
      <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-245">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-246">
          Recherches sauvegardées
        </h2>
        <button className="text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center" data-id="element-247">
          <SearchIcon size={16} className="mr-1" data-id="element-248" />
          Nouvelle recherche
        </button>
      </div>
      {savedSearches.length > 0 ? <ul className="divide-y divide-gray-200" data-id="element-249">
          {savedSearches.map(search => <li key={search.id} className="px-6 py-4 hover:bg-gray-50" data-id="element-250">
              <div className="flex justify-between items-start" data-id="element-251">
                <div data-id="element-252">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-253">
                    {search.name}
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-254">
                    {search.criteria}
                  </p>
                  <div className="mt-2 flex items-center" data-id="element-255">
                    <span className="text-xs text-gray-500" data-id="element-256">
                      {search.lastResults} résultats trouvés
                    </span>
                    <span className="mx-2 text-gray-300" data-id="element-257">|</span>
                    <button className="text-xs text-blue-600 hover:text-blue-800" data-id="element-258">
                      Voir les résultats
                    </button>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-259">
                  <button className={`p-1.5 rounded-md ${search.alertsEnabled ? 'text-yellow-500 hover:text-yellow-600 bg-yellow-50' : 'text-gray-400 hover:text-gray-500 hover:bg-gray-100'}`} data-id="element-260">
                    {search.alertsEnabled ? <BellIcon size={16} data-id="element-261" /> : <BellOffIcon size={16} data-id="element-262" />}
                  </button>
                  <button className="p-1.5 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100" data-id="element-263">
                    <EditIcon size={16} data-id="element-264" />
                  </button>
                  <button className="p-1.5 rounded-md text-gray-400 hover:text-red-500 hover:bg-gray-100" data-id="element-265">
                    <TrashIcon size={16} data-id="element-266" />
                  </button>
                </div>
              </div>
            </li>)}
        </ul> : <div className="px-6 py-8 text-center" data-id="element-267">
          <SearchIcon className="mx-auto h-12 w-12 text-gray-300" data-id="element-268" />
          <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-269">
            Aucune recherche sauvegardée
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-270">
            Commencez par créer une recherche personnalisée pour suivre les
            appels d'offres qui vous intéressent.
          </p>
          <div className="mt-6" data-id="element-271">
            <button className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700" data-id="element-272">
              <SearchIcon className="-ml-1 mr-2 h-5 w-5" data-id="element-273" />
              Créer une recherche
            </button>
          </div>
        </div>}
    </div>;
}